import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Modules Material utilises
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';

// Autres modules externes utilises 

// Modules communs utilises
import { BootstrapPopupModule } from '../../shared/bootstrap-popup/bootstrap-popup.module';
import { JSR310LocalDatesModule } from '../../shared/jsr310-localdates/jsr310-localdates.module';
import { PannelModule } from '../../shared/pannel/pannel.module';

// Modules metier utilises
import { UserModule } from '../../data-domains/humain/user/user.module';

// Composants metiers
import { JobProgressComponent } from './components/job-progress';
import { JobProgressDialogComponent } from './components/job-progress-dialog';
import { JobsFiltersComponent } from './components/jobs-filters.component';
import { JobsSupervisionComponent } from './components/jobs-supervision.component';
import { JobsTableComponent } from './components/jobs-table.component';
 
// Services metier
import { JobService } from './services/job.service';

// Bridges avec la partie angular

@NgModule({
	imports: [
		BrowserModule,
		FormsModule,
		ReactiveFormsModule,

		MatPaginatorModule,
		MatProgressBarModule,
		MatTableModule,
		MatSortModule,
		
		BootstrapPopupModule,
		JSR310LocalDatesModule,
		PannelModule,
		
		UserModule,
	],
	providers: [
		JobService,
	],
	declarations: [
		JobProgressComponent,
		JobProgressDialogComponent,
		JobsFiltersComponent,
		JobsSupervisionComponent,
		JobsTableComponent,
	],
	exports: [
		JobProgressComponent,
		JobProgressDialogComponent,
		JobsSupervisionComponent,
	]
})
export class JobsModule {
	constructor() { }
}